import { render, staticRenderFns } from "./TheGoBackToCallButton.vue?vue&type=template&id=317484fa"
import script from "./TheGoBackToCallButton.vue?vue&type=script&lang=js"
export * from "./TheGoBackToCallButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports